import Container from "../Container";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import Card from "./Card";
import { v4 as uuid } from "uuid";
import { data } from "./data";

export default function Stack() {
  return (
    <section className={classes.section}>
      <Container>
        <Title
          title="Technology stack"
          number={"01"}
          className={classes.title}
        />
        <ul className={classes.list}>
          {data.map(({ image, title, text }) => (
            <li key={uuid()} className={classes.list__item}>
              <Card image={image} title={title} text={text} />
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
